import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import UserWidget from '../../widgets/UserWidget';
import Table from '../../widgets/tables/Table';
import getUtenti from '../../services/getUtenti';
import removeUser from '../../services/removeUser';
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";

let t = translateString;

export default class DatabaseUsers extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
      showNewUserWidget: false,
      isLoading: true,
    };

  }

  async loadComponent() {
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    Utils.setAnalyticsPage('New admin/billing user creation - ' + cookies.get('db', { path: '/' }));

    this.utenti = await getUtenti(username, token);
    this.utenti.forEach((utente) => {
        utente.type = utente.type == 0 ? 'ADMIN' : 'BILLING';
    });
    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.loadComponent();    
  }

  render () {

    var headCells = [
      { id: 'username', numeric: true, disablePadding: false, label: 'Username' },
      { id: 'type', numeric: true, disablePadding: false, label: t('tipologia') },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['username'];

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    if (this.state.isLoading) return <div />

    return (
      <>
        <div>
        <PageTitle title={t('utenti')} button={ t('aggiungi') } onClick={() => this.setState({ showNewUserWidget: true })} />
          <Table headCells={headCells} searchCols={this.searchCols} rows={this.utenti} mail={false} phone={false} calendar={false} pdf={false}
            onEventClick={(row) => {
              // Open user widget
            }}
            
            onDelete={ async (row) => {

              var proceed = true;
              this.utenti.forEach((utente) => {
                if (utente.id == row && utente.username == username) {
                  Utils.showError(t('errore_utente_corrente'));
                  proceed = false;
                }
              }); 

              if (proceed) {
                if(window.confirm(t('elimina_utente'))) {
                    let res = await removeUser(username, token, row);
                    if (res != null && res.result == 'ok') {
                      this.loadComponent();
                    } else {
                      Utils.showError(t('errore_imprevisto'));
                    }
                }
              }
            }} />
        { this.state.showNewUserWidget && (
          <UserWidget onCancel={() => { this.setState({ showNewUserWidget: false }); this.loadComponent(); }} />
        )}
        </div>
      </>
    );
  }
}

